import {ReadPage} from '@tinct/core-api-models';

/** The campaign projection the preview gate reads. */
export type PreviewGateCampaign = {
  status?: string | null;
  snippetStatus?: { status?: string | null } | null;
} | null;

/**
 * Why the internal variant preview cannot open, or null when it can. The
 * preview loads the customer's page with the snippet, so it needs the variant
 * live, the campaign live and the snippet detected.
 */
export function getPreviewBlockedReason({
  status,
  campaign,
}: {
  status: ReadPage['status'];
  campaign?: PreviewGateCampaign;
}): string | null {
  if (status !== 'published') return 'Variant must be published to be previewed';
  if (campaign?.status !== 'published') return 'Campaign must be live to preview its variants';
  if (campaign?.snippetStatus?.status !== 'active')
    return 'Tinct snippet must be installed on your website to preview variants';
  return null;
}

// No memoization: the result is a string (or null) derived from three scalar
// reads, so there is nothing referential to keep stable.
export function usePreviewBlockedReason({
  status,
  campaign,
}: {
  status: ReadPage['status'];
  campaign?: PreviewGateCampaign;
}): string | null {
  return getPreviewBlockedReason({ status, campaign });
}
